import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Construction, ArrowRight, GlassWater } from 'lucide-react';

export default function MenuPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 fade-in" data-testid="menu-page">
      <div className="text-center">
        <div className="w-20 h-20 rounded-2xl mx-auto mb-6 flex items-center justify-center" style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.2)' }}>
          <GlassWater className="w-10 h-10 text-[#D4AF37]" />
        </div>

        <h1 className="text-3xl sm:text-4xl font-light tracking-tight mb-4" style={{ fontFamily: 'Outfit' }}>
          CARTE DES MOCKTAILS
        </h1>

        <div className="bg-[#121212] border border-[#D4AF37]/20 rounded-2xl p-8 md:p-12 mb-8" style={{ boxShadow: '0 0 40px rgba(212,175,55,0.04)' }}>
          <Construction className="w-12 h-12 text-[#D4AF37] mx-auto mb-4" />
          <h2 className="text-xl font-semibold mb-3" style={{ fontFamily: 'Outfit', color: '#D4AF37' }}>
            Carte en cours de développement
          </h2>
          <p className="text-[#A1A1AA] leading-relaxed max-w-md mx-auto">
            Notre nouvelle carte de mocktails arrive bientôt !
            En attendant, n'hésitez pas à nous contacter pour découvrir
            nos créations et personnaliser votre événement.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/reservation" data-testid="carte-devis-btn">
            <Button className="bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full px-8 py-3 text-sm font-semibold">
              Demander un devis <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Link to="/contact" data-testid="carte-contact-btn">
            <Button variant="outline" className="border-white/20 text-white hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 rounded-full px-8 py-3 text-sm">
              Nous contacter
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
